// Helper function: Calculate distance between two points (unit: kilometers)
export const calculateDistance = (point1, point2) => {
  const R = 6371; // Earth radius in kilometers
  const dLat = toRad(point2.latitude - point1.latitude);
  const dLon = toRad(point2.longitude - point1.longitude);
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(toRad(point1.latitude)) * Math.cos(toRad(point2.latitude)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2); 
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  return R * c;
};

// Helper function: Convert degrees to radians
export const toRad = (value) => {
  return value * Math.PI / 180;
};

// Calculate path details
export const calculatePathDetails = (path, locations) => {
  let totalDistance = 0;
  const segments = [];
  
  for (let i = 0; i < path.length - 1; i++) {
    const loc1 = locations.find(loc => loc.id === path[i]);
    const loc2 = locations.find(loc => loc.id === path[i + 1]);
    
    if (loc1 && loc2) {
      const distance = calculateDistance(loc1, loc2);
      totalDistance += distance;
      
      segments.push({
        from: loc1,
        to: loc2,
        distance: distance,
        fromIndex: i,
        toIndex: i + 1
      });
    }
  }
  
  return { distance: totalDistance, segments: segments };
};

// Get autoPath vehicle path information
export const getAutoVehiclePaths = (autoPath) => {
  if (!autoPath) return null;
  
  // Check if autoPath has vehiclePaths property
  if (autoPath.vehiclePaths && Array.isArray(autoPath.vehiclePaths) && autoPath.vehiclePaths.length > 0) {
    return autoPath.vehiclePaths;
  }
  
  return null;
};

// Removed unused helper functions - simplified for unified reading approach

// Get customPath vehicle path information - Simplified to match auto path reading
export const getCustomVehiclePaths = (customPath) => {
  if (!customPath) return null;
  
  // Simplified logic - same as auto path reading
  if (customPath.vehiclePaths && Array.isArray(customPath.vehiclePaths) && customPath.vehiclePaths.length > 0) {
    return customPath.vehiclePaths;
  }
  return null;
}; 